import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import emailjs from 'emailjs-com';
import { useTexts } from '../../../hooks/useTexts';
import './Contact.css';

/*
 * ============================================================
 *  EMAILJS — configure suas credenciais aqui
 *  1. Crie conta em https://www.emailjs.com (gratuito)
 *  2. Crie um serviço de e-mail e um template
 *  3. Substitua os valores abaixo
 * ============================================================
 */
const EMAILJS_SERVICE_ID = 'portfolio_service';
const EMAILJS_TEMPLATE_ID = 'template_ihvpldt';
const EMAILJS_PUBLIC_KEY = 'EzAJjQcuf2nCkK4fQ';

export default function Contact() {
  const t = useTexts();
  const formRef = useRef(null);
  const [status, setStatus] = useState(null); // null | 'sending' | 'ok' | 'error'

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs
      .sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, formRef.current, EMAILJS_PUBLIC_KEY)
      .then(() => {
        setStatus('ok');
        formRef.current.reset();
        setTimeout(() => setStatus(null), 5000);
      })
      .catch(() => setStatus('error'));
  };

  return (
    <section className="contact-section" id="contact">
      <motion.div
        className="contact-left"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <p className="section-num">{t.contact.sectionNum}</p>
        <h2 className="contact-big">
          {t.contact.title1}<br />
          <span className="accent">{t.contact.title2}</span><br />
          <span className="outline">{t.contact.title3}</span>
        </h2>
      </motion.div>

      <motion.div
        className="contact-right"
        initial={{ opacity: 0, x: 24 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.15 }}
      >
        <form ref={formRef} className="contact-form" onSubmit={handleSubmit}>
          <div className="form-field">
            <label className="form-label">{t.contact.nameLabel}</label>
            <input
              className="form-input"
              type="text"
              name="from_name"
              placeholder={t.contact.namePlaceholder}
              required
            />
          </div>
          <div className="form-field">
            <label className="form-label">{t.contact.emailLabel}</label>
            <input
              className="form-input"
              type="email"
              name="reply_to"
              placeholder={t.contact.emailPlaceholder}
              required
            />
          </div>
          <div className="form-field">
            <label className="form-label">{t.contact.projectLabel}</label>
            <textarea
              className="form-input form-textarea"
              name="message"
              placeholder={t.contact.projectPlaceholder}
              rows={4}
              required
            />
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={status === 'sending'}
          >
            {status === 'sending' ? '...' : t.contact.sendBtn}
          </button>

          {status === 'ok' && (
            <p className="form-status form-status--ok">{t.contact.success}</p>
          )}
          {status === 'error' && (
            <p className="form-status form-status--err">{t.contact.error}</p>
          )}
        </form>
      </motion.div>
    </section>
  );
}
